import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <div className="nk-footer user-select-none">
            <div className="container-fluid">

                <div className=" text-center text-black">

                    Copyright © 2022 Limtzo Powered By Howin<span className="text-danger fw-bolder">Cloud</span> All rights reserved.
                </div>



            </div>
        </div>
    );
};
export default Footer;
